import { type UserInterface } from '../Interface/UserInterface';
import AuthService from '../Services/AuthService';

export class User {
  static user: UserInterface;

  static getUser = () => User.user;
  static getSwitchUser = () => {
    const switchUser = AuthService.getSwitchUser();
    return switchUser;
  };

  constructor(user: UserInterface) {
    User.user = user;
  }
}
